/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RootDoubleConferenceAliases {
  AVATAR_DOUBLE_CONFERENCE = 'avatar-double-conference',
  DOUBLE_CONFERENCE = 'double-conference',
  DOUBLE_CONFERENCE_FRAGMENT = 'double-conference-fragment',
  DOUBLE_CONFERENCE_ROUTE_LAYOUT = 'double-conference-route-layout',
  HANDLING_ORDER_ITEMS = 'handling-order-items',
  HANDLING_ORDER_ITEMS_FRAGMENT = 'handling-order-items-fragment',
  PANEL_RESOLUTION = 'panel-resolution',
  TEXT_RESOLUTION_SUPORTED = 'text-resolution-suported',
}
export { RootDoubleConferenceAliases };
